import React, { useState } from 'react';
import { AnimatePresence, MotionConfig, motion } from 'framer-motion';
import { revealContainer } from '../common/Reveal';
import { AppHeader } from '../layout/AppHeader';
import type { ViewTab } from '../layout/NavTabs';
import { FloorView } from '../views/FloorView';
import { HomeView } from '../views/HomeView';
import { ReportsView } from '../views/ReportsView';
import { LeaderboardView } from '../views/LeaderboardView';
import { UsersView } from '../views/UsersView';
import { UserDetailDrawer } from '../users/UserDetailDrawer';
import { RangeSelect } from '../common/RangeSelect';
import { TeamSelect } from '../common/TeamSelect';
import { useCallsInsightHub } from './useCallsInsightHub';
import { scopeLabels } from '../../utils/range';
import { dateLabel } from '../../utils/floor';
export function CallsInsightHub() {
  const hub = useCallsInsightHub();
  const [tab, setTab] = useState<ViewTab>('floor');
  return <MotionConfig reducedMotion="user" data-id="element-85" data-mp="3l9nohrt7bqft">
    <div className="min-h-screen w-full bg-canvas text-ink" data-id="element-86" data-mp="223noxet9ni7x">
      <AppHeader tab={tab} onTabChange={setTab} controls={tab === 'home' ? <>
              <RangeSelect value={hub.range} onChange={hub.setRange} data-id="element-88" data-mp="2b4dgu7feoogd" />
              <TeamSelect value={hub.team} onChange={hub.setTeam} data-id="element-89" data-mp="2b2iucoohkoa6" />
            </> : undefined} data-id="element-87" data-mp="2261fbad04695" />

      <main className="relative z-10 mx-auto max-w-[1440px] px-4 py-8 sm:px-6 lg:px-10" data-id="element-90" data-mp="2l2jeudy3dafy">
        <motion.div key={tab} id={`panel-${tab}`} role="tabpanel" aria-labelledby={`tab-${tab}`} variants={revealContainer} initial="hidden" animate="show" data-id="element-91" data-mp="2g3q06i72jde7">
          {tab === 'floor' && <FloorView hub={hub} data-id="element-92" data-mp="2put37pjk62g4" />}
          {tab === 'home' && <HomeView hub={hub} onNavigate={setTab} data-id="element-93" data-mp="33t14g9nmnpx3" />}
          {tab === 'reports' && <ReportsView hub={hub} data-id="element-94" data-mp="33r6eui1ev9mo" />}
          {tab === 'leaderboard' && <LeaderboardView hub={hub} data-id="element-95" data-mp="2yviseaebcukv" />}
          {tab === 'users' && <UsersView hub={hub} data-id="element-96" data-mp="1wh1pnhgv6ptk" />}
        </motion.div>
      </main>

      <AnimatePresence data-id="element-97" data-mp="1weozih0yd95f">
        {hub.selected && <UserDetailDrawer key={hub.selected.agent.id} row={hub.selected} floorRow={hub.floorById.get(hub.selected.agent.id)} floorDateLabel={dateLabel(hub.floorDate)} scopeLabel={scopeLabels[hub.range]} source={hub.voiceSource} onClose={() => hub.setSelectedId(null)} data-id="element-98" data-mp="20hlpissto7je" />}
      </AnimatePresence>
    </div>
    </MotionConfig>;
}